import { KeyboardEvent, useRef, useState } from 'react'

const useTreeItem = (title: string, customTitle?: string, onRename?: (next: string) => void) => {
  const [rename, setRename] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const [tempName, setTempName] = useState(customTitle || title)

  const handleRenameInput = (value: string) => {
    setTempName(value)
  }

  const handleRenameKeydown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      setRename(false)
    }
    if (e.key === 'Enter') {
      const value = e.currentTarget.value.trim()
      setTempName(value)
      onRename?.(value)
      setRename(false)
    }
  }

  const handleSaveRename = () => {
    onRename?.(tempName.trim())
    setTempName(tempName.trim())
    setRename(false)
  }

  return {
    rename,
    inputRef,
    tempName,
    handleRenameInput,
    handleRenameKeydown,
    setTempName,
    setRename,
    handleSaveRename,
  }
}

export default useTreeItem
